import { useTranslation } from "react-i18next";

import { AppLayout } from "@/components/AppLayout";
import { PermissionGate } from "@/components/PermissionGate";
import { CustomFieldsCard } from "@/modules/admin";

export default function AdminCustomFieldsPage() {
  const { t } = useTranslation();
  return (
    <AppLayout
      title={t("admin.fields.pageTitle")}
      description={t("admin.fields.pageDescription")}
    >
      <PermissionGate
        perm="org.update"
        fallback={
          <p className="card text-sm text-nb-text-2">
            {t("admin.noPermission")}
          </p>
        }
      >
        <CustomFieldsCard />
      </PermissionGate>
    </AppLayout>
  );
}
